export const AUTH_FORM_TITLE_ID = 'auth-form-title'

export function focusFormTitle() {
  requestAnimationFrame(() => document.getElementById(AUTH_FORM_TITLE_ID)?.focus())
}
